var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"05e4b0ed3a213cbbfbe5aa78ddbeb76b9244c8c1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["os-arg-provincia-salta@os-city"]={id:"05e4b0ed3a213cbbfbe5aa78ddbeb76b9244c8c1"};
      